import AOS from 'aos';
import 'aos/dist/aos.css';

document.addEventListener('DOMContentLoaded', _=> {
    if(document.querySelector('[data-aos]')) {
        AOS.init();
    }
})
